import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as Highcharts from "highcharts";
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { TechnicalDashboardService } from 'src/app/services/technical-dashboard.service';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})
export class DetailsComponent implements OnInit {

  timePeriods = [
    { name: "1 Hour", value: '1h' },
    { name: "6 Hour", value: '6h' },
    { name: "12 Hour", value: '12h' },
    { name: "24 Hour", value: '24h' },
    { name: "7 Days", value: '7d' },
    { name: "30 Days", value: '30d' },
  ];

  serverDetailsLeft = [
    { label: 'Name', key: 'name' },
    { label: 'Description', key: 'description' },
    { label: 'Server', key: 'serverType' },
    { label: 'CPU', key: 'cpu' },
    { label: 'RAM', key: 'ram' },
    { label: 'Storage', key: 'storage' },
    { label: 'Available C-Drive Space', key: 'availableCDriveSpace' },
    { label: 'Total C-Drive Space', key: 'totalCDriveSpace' }
  ];

  serverDetailsRight = [
    { label: 'Total Users', key: 'totalUsers' },
    { label: 'Active Users', key: 'activeUsers' },
    { label: 'InActive Users', key: 'inActiveUsers' },
    { label: 'Free Users', key: 'freeUsers' },
    { label: 'Paid Users', key: 'paidUsers' },
    { label: 'Trial Users', key: 'trialUsers' },
    { label: 'Currently LoggedIn', key: 'currentlyLoggedIn' },
  ];

  subDetails = [
    { label: 'Sub Id', key: '_id' },
    { label: 'Total Users', key: 'totalUsers' },
    { label: 'Currently LoggedIn', key: 'currentlyLoggedInUser' }
  ];

  Highcharts: typeof Highcharts = Highcharts;
  highChartData = { title: { text: '' }, accessibility: { enabled: false } }
  loginTrendOption: Highcharts.Options = this.highChartData;
  updateFromInput: boolean = true
  objFromInput: any = {}
  chartType: string = 'column'
  activeLoginSection = '1h'
  serverId: any
  details: any
  subId: any

  constructor(
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private technicalDashboardService: TechnicalDashboardService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      if (params['serverId']) {
        this.serverId = params['serverId'];
        this.getDetailsServerWiseReport({ serverId: this.serverId })
      }
    });
    this.dateRange(this.activeLoginSection);

  }

  currentTimePeriod(type: any): void {
    this.activeLoginSection = type
    this.dateRange(this.activeLoginSection)
  }

  toggleChartType(graph: string) {
    this.chartType = graph
    this.dateRange(this.activeLoginSection)
  }


  dateRange(range: string) {
    const payload = {range, serverId: this.serverId};
    this.loginTrendData(payload);
  }

  loginTrendData(payload: any): void {
    this.technicalDashboardService.loginTrendGraph(payload).subscribe({
      next: (res: any) => {
        const chartData = (res.graphData || []).map((obj: any) => {
          const time = moment(obj._id).add(330, 'minutes').toISOString();
          return {
            ...obj,
            timestamp: this.convertToUnixTime(time),
          };
        });

        const serverWiserData = [
          {
            name: 'Number of Logins',
            yaxisName: 'Logins',
            color: '#4B49AC',
            data: chartData.map((obj: any) => [obj.timestamp, parseInt(obj.currentlyLoggedIn)]),
          },
        ];

        this.updateChartData(serverWiserData, 'loginTrendChart');
      },
      error: (err: any) => {
        const errorMessage = err?.error?.message || 'An unexpected error occurred.';
        this.toastr.error(errorMessage);
      },
    });
  }

  updateChartData(chartData: any[], chartId: string): void {
    const chartConfig: Highcharts.Options = {
      credits: { enabled: false },
      chart: { type: this.chartType },
      legend: {
        align: 'center',
        verticalAlign: 'top',
        padding: 0,
        enabled: true,
        symbolRadius: 0,
        squareSymbol: false,
        symbolWidth: 40,
      },
      title: { text: '' },
      xAxis: {
        type: 'datetime',
        labels: {
          // formatter: function (this: Highcharts.AxisLabelsFormatterContextObject<any>) {
          //   return Highcharts.dateFormat('%H:%M', this.value as number);
          // }
        }
      },
      yAxis: {
        title: { text: chartData[0]?.yaxisName || '' },
      },
      plotOptions: {
        areaspline: {
          marker: {
            enabled: false,
            symbol: 'circle',
            radius: 2,
            states: { hover: { enabled: true } },
          }
        }
      },
      series: chartData.map(obj => ({
        type: obj.chartType,
        name: obj.name,
        data: obj.data,
        color: obj.color || undefined,
        legendSymbol: 'rectangle',
      })),
      accessibility: { enabled: false },
    };

    Highcharts.chart(chartId, chartConfig);
    this.updateFromInput = true;
  }

  convertToUnixTime(dateTimeString: string): number {
    const formattedDateTime = dateTimeString.replace(/(\+|-)(\d{2})(\d{2})$/, '$1$2:$3');
    const date = new Date(formattedDateTime);
    // const offset = 5.5 * 60 * 60 * 1000; // IST offset
    // return date.getTime() + offset;
    return date.getTime();
  }

  getDetailsServerWiseReport(payload: any) {
    this.technicalDashboardService.serverWiseReportDetails(payload).subscribe({
      next: (res: any) => {
        this.details = res.serverReport[0]
      }
    })
  }
}
